import { useEffect } from "react";

/**
 * Hook that observes an element for size changes and calls onResize.
 * @param {React.RefObject} ref - Ref to the DOM element to observe
 * @param {Function} onResize - Callback invoked when element resizes
 */
export default function useResizeObserver(ref, onResize) {
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const ro = new ResizeObserver(() => {
      onResize();
    });
    ro.observe(element);
    return () => ro.disconnect();
  }, [ref, onResize]);
}
